import i18next  from 'i18next';

import es from './es';
import pt from './pt';
import en from './en';

i18next.addResourceBundle('es', 'myAccount', es);
i18next.addResourceBundle('en', 'myAccount', en);
i18next.addResourceBundle('pt', 'myAccount', pt);